import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Appointment from "./sections/Appointment";
import Location from "./sections/Location";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Appointment />
      <Location />
      <Faq />
      <Footer />
    </div>;
}